import { Injectable } from '@angular/core';
import { Rack } from '../interfaces/rack';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RackCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/racks/' ;
  }

  // Create Rack
  add(record: Rack) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Rack Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Racks List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Rack Object
  update(record: Rack) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Rack>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Rack Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
